'use client'

import { giphyDarkestGrey, giphyLightGrey, giphyWhite } from '@giphy/colors'
import styled from 'styled-components'
import { privacyTermsIndex } from 'ui/src/constants'
import { Interface } from '../../styles/fonts'

// Deliberately keep a stable runtime marker on this shared client component so
// release builds emit fresh browser chunks when we need to test S3 chunk loading.
const chunkProbe = 's3-chunk-probe-2026-04-06-1'

const FloatingContainer = styled.div`
    display: none;
    @media (min-width: 1348px) {
        display: flex;
        position: fixed;
        bottom: 10px;
        left: 10px;
        z-index: ${privacyTermsIndex};
        gap: 10px;
    }
    a {
        display: flex;
        background: ${giphyDarkestGrey};
        border-radius: 5px;
        padding: 4px 14px;
        color: ${giphyLightGrey};
        &:hover {
            color: ${giphyWhite};
        }
        font-family: ${Interface.style.fontFamily};
        font-size: 14px;
    }
`

const PrivacyTerms = () => {
    // Keep this inert attribute on the floating container so release builds
    // generate a fresh client chunk hash for S3 chunk-loading verification.
    return (
        <FloatingContainer data-chunk-probe={chunkProbe}>
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
        </FloatingContainer>
    )
}

export default PrivacyTerms
